import { forwardRef } from "react";
import { Copy, Download, QrCode, Share2 } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import SectionIcon from "./SectionIcon";

const MenuShareCard = forwardRef(function MenuShareCard(
  { publicMenuUrl, logoUrl, unavailableMessage, onCopy, onShare, onDownload },
  ref
) {
  return (
    <section className="rounded-xl border border-gray-200 bg-white p-5" aria-labelledby="menu-share-title">
      <div className="flex items-center gap-3">
        <SectionIcon icon={QrCode} tone="green" />
        <div className="min-w-0">
          <h2 id="menu-share-title" className="text-sm font-extrabold text-accent">اشتراک‌گذاری منو</h2>
          <p className="mt-0.5 text-[11px] text-gray-500">لینک و QR منوی آنلاین</p>
        </div>
      </div>

      {publicMenuUrl ? (
        <>
          <div className="mt-4 flex justify-center rounded-xl bg-secondary_1 p-5">
            <div ref={ref} className="flex flex-col items-center gap-2 rounded-lg bg-white p-3">
              <QRCodeCanvas value={publicMenuUrl} size={128} level="H" />
              <img src={logoUrl} alt="لوگوی رستوران" className="h-5 max-w-24 object-contain" />
            </div>
          </div>

          <div className="mt-3 flex items-center gap-1 rounded-lg bg-gray-50 py-1 pl-1 pr-3">
            <p className="min-w-0 flex-1 truncate text-[11px] text-gray-500" dir="ltr">{publicMenuUrl}</p>
            <button type="button" onClick={onCopy} aria-label="کپی لینک منو" title="کپی لینک" className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-gray-500 hover:bg-white hover:text-accent focus:outline-none focus:ring-2 focus:ring-gray-200">
              <Copy size={14} aria-hidden="true" />
            </button>
          </div>

          <div className="mt-2 grid grid-cols-2 gap-2">
            <button type="button" onClick={onDownload} className="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-gray-200 text-xs font-bold text-accent hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100">
              <Download size={14} aria-hidden="true" />
              دانلود QR
            </button>
            <button type="button" onClick={onShare} className="inline-flex h-9 items-center justify-center gap-1.5 rounded-lg border border-gray-200 text-xs font-bold text-accent hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100">
              <Share2 size={14} aria-hidden="true" />
              اشتراک
            </button>
          </div>
        </>
      ) : (
        <p className="mt-3 rounded-lg bg-gray-50 p-3 text-xs leading-5 text-gray-500">
          {unavailableMessage || "لینک عمومی رستوران هنوز تنظیم نشده است؛ به همین دلیل QR قابل ساخت نیست."}
        </p>
      )}
    </section>
  );
});

export default MenuShareCard;
